import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

type SectionProps = {
  children: ReactNode;
  id?: string;
  /**
   * `givre` laisse voir le fond de page, `blanc` alterne, `encre` inverse
   * (texte blanc, labels à 70 %).
   */
  tone?: 'givre' | 'blanc' | 'encre';
  className?: string;
  'aria-labelledby'?: string;
  'aria-label'?: string;
};

/** Rythme vertical : 96 px, 60 px sous 720 px (maquette). */
export function Section({ children, id, tone = 'givre', className, ...rest }: SectionProps) {
  return (
    <section
      id={id}
      className={cn(
        'py-15 tab:py-24',
        tone === 'blanc' && 'bg-blanc',
        tone === 'encre' && 'bg-encre text-blanc',
        className,
      )}
      {...rest}
    >
      {children}
    </section>
  );
}
